import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { environment } from '../../../../environments/environment';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
  selector: 'app-common-list',
  templateUrl: './common-list.component.html',
  styleUrls: [
    './common-list.component.scss',
    "../../../../assets/sass/libs/datatables.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CommonListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  public ColumnMode = ColumnMode;

  @Input() listFields: Array<any> = [];
  @Input() dataList: Array<any> = [];
  @Input() limit = 10;
  @Input() page = 1;
  @Input() listCount: number = 0; // total rows from server

  @Output() pageNumber = new EventEmitter();
  @Output() deleteById = new EventEmitter();
  @Output() downloadPath = new EventEmitter();

  @Input() editRoutePath: string = '/';
  @Input() editRoutePayoutPath: string = '/';
  @Input() viewRoutePath: string = '/';
  @Input() param1: string = '';
  @Input() param2: string = '';
  @Input() editKey: string = '_id';

  @Input() showAction: any = {
    edit: true,
    view: false,
    payout: false,
    delete: false,
    download: false,
  };

  env: any;

  // PAGINATION
  pageSizes = [3, 10, 25, 50, 100, 999];

  get totalPages() {
    return Math.ceil(this.listCount / this.limit);
  }

  constructor(
    public hp: HelperService,
    private cdr: ChangeDetectorRef,
  ) {
    this.env = environment;
  }

  ngOnInit(): void { }

  onLimitChange() {
    this.page = 1;
    this.pageNumber.emit({ page: this.page, limit: this.limit });
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.pageNumber.emit({ page: this.page, limit: this.limit });
    }
  }

  previousPage() {
    if (this.page > 1) {
      this.page--;
      this.pageNumber.emit({ page: this.page, limit: this.limit });
    }
  }

  pageChange() {
    this.pageNumber.emit(this.page);
  }

  download(path: any) {
    this.downloadPath.emit(path);
  }

  GetFieldByIndex(r: any, fieldName: any) {
    let string = r[fieldName];
    if (string === undefined) {
      let str = fieldName.split('.');
      let temp = r;
      for (let i = 0; i < str.length; i++) {
        if (temp && temp.hasOwnProperty(str[i])) {
          temp = temp[str[i]];
        } else {
          return "NA";
        }
      }
      string = temp;
    }
    return string;
  }

  deleteService(deleteById: any) {
    return this.deleteById.emit(deleteById);
  }
}
